import { Component, OnInit, signal } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { Observable, of } from "rxjs";
import {
  LEVEL_PUBLISHED,
  PARAM_BRANDS_PATH,
  PARAM_CATEGORIES_PATH,
  PARAM_CORSI_PATH,
  STATE_LIST,
  STATE_PUBLISHED,
} from "src/app/admin/constants/constants";
import { AbstractFormComponent } from "src/app/common/abstract-edit.component";
import { Brand } from "src/app/models/brand";
import { Corsi } from "src/app/models/corsi";
import { News } from "src/app/models/news";
import { CorsiService } from "src/app/services/corsi.service";
import { NewsService } from "src/app/services/news.service";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { EditorModule } from "primeng/editor";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { ReactiveFormsModule } from "@angular/forms";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { SelectButtonModule } from "primeng/selectbutton";
import { SelectModule } from "primeng/select";
import { TabsModule } from "primeng/tabs";
import { ToastModule } from "primeng/toast";
import { TopNavComponent } from "../../../top-nav/top-nav.component";
import { UploadComponent } from "../../components/upload/upload.component";
import { UploadCorsiComponent } from "../../components/upload-corsi/upload-corsi.component";
import { UploadFilesComponent } from "../../components/upload-files/upload-files.component";

@Component({
    selector: "app-corsi-form",
    templateUrl: "./corsi-form.component.html",
    imports: [ButtonModule, CardModule, ConfirmDialogModule, EditorModule, SharedModule, FormsModule, InputTextModule, ReactiveFormsModule, Ripple, RouterLink, SelectButtonModule, SelectModule, TabsModule, ToastModule, TopNavComponent, UploadComponent, UploadCorsiComponent, UploadFilesComponent]
})
export class CorsiFormComponent
  extends AbstractFormComponent<Corsi>
  implements OnInit
{
  pageTitle = signal("");
  form: FormGroup;
  idField = "id";
  formFields = [
    "id",
    "page_title",
    "page_url",
    "page_seotitle",
    "page_seodescription",
    "description_1",
    "description_2",
    "description_3",
    "is_featured",
    "level",
    "status",
    "is_active",
  ];
  item$: Observable<News> = of(); // Initialize with an empty Observable
  stateOptions = STATE_LIST;
  service = this.corsiService; // Implement the abstract service property
  element = signal<Corsi | null>(null);
  selectedStatePublished: SelectItem[] = [];
  selectedLevelPublished: SelectItem[] = [];
  statePublished: any[];
  levelPublished: any[];
  constructor(
    protected fb: FormBuilder,
    private corsiService: CorsiService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(
      fb,
      messageService,
      confirmationService,
      router,
      route,
      PARAM_CORSI_PATH
    );
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle.set("Modifica Corso");
      this.loadItem(+id);
    } else {
      this.pageTitle.set("Aggiungi Corso");
    }

    this.statePublished = STATE_PUBLISHED;
    this.levelPublished = LEVEL_PUBLISHED;
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      page_title: ["", Validators.required],
      page_template: [""],
      page_url: [""],
      description_1: [""],
      description_2: [""],
      description_3: [""],
      page_seotitle: [""],
      is_featured: [""],
      page_seokeywords: [""],
      page_seodescription: [""],
      level: [""],
      status: [""],
      is_active: ["0"],
    });
  }

  loadItem(id: number) {
    this.service.getId(id).subscribe(
      (res) => {
        this.element.set(res);
        this.form.patchValue({
          page_title: res.page_title,
          page_url: res.page_url,
          description_1: res.description_1,
          description_2: res.description_2,
          description_3: res.description_3,
          page_seotitle: res.page_seotitle,
          page_seokeywords: res.page_seokeywords,
          page_seodescription: res.page_seodescription,
          status: res.status,
          level: res.level,
          is_active: res.is_active,
          is_featured: res.is_featured,
          id: res.id,
        });
      },
      (error) => (this.error.set(error))
    );
  }
}
